import ShareableLinkAuthorized from './ShareableLinkAuthorized.component';

export default ShareableLinkAuthorized;
